import React from 'react';

export default class Text extends React.Component {
  constructor(props) {
    super(props);
    let ix = props.ix ? props.ix : 0;
    this.state = {
      value: this.props.value,
      changed: false,
      ix: ix
    };
    this.intervalId = -1;
  }

  componentWillUnmount(){
    if(this.state.changed)
      this.up();
  }

  componentDidUpdate(prevProp, prevState){
    if(prevProp.value !== this.props.value){
      this.setState({
        value: this.props.value,
        changed: true,
      }, () => { this.up() })
    }
  }

  handleChange = (e) => {
    const val = e.target.value;
    this.setState({
      value: val,
      changed: true
    }, ()=>{
      this.intervalId = setTimeout(() => { this.up() }, (this.props.ix * 10) + 500);
    })
    e.preventDefault();
  }

  handleFocus(event) {
    event.target.select();
  }

  onBlur = () => {
    this.up();
  }

  up = () =>{
    if((this.state.changed==true)&&(this.props.callback!=null)){
      this.props.callback({
        field: this.props.name,
        value: this.state.value
      });
      if(this.props.hasOwnProperty('onChange'))
        this.props.onChange();
    }
    this.setState({
      changed: false
    })
    clearInterval(this.intervalId);
  }

  render() {
    return (
        <input
          type="text"
          name={this.props.name}
          placeholder={this.props.ph}
          value={this.state.value}
          className="form-control"
          autoComplete="off"
          onFocus={this.handleFocus}
          onBlur={this.handleChange}
          required={this.props.required}
          onInput={this.handleChange}
          required={this.props.required}
        />
    );
  }
}
